<template>
  <b-button v-bind="$props" :disabled="fetching" @click.prevent="onClick">
    <b-spinner v-if="fetching" small></b-spinner>
    <slot v-else name="icon"></slot>
    <span class="m-1" v-if="separator"></span>
    <slot></slot>
    {{slot}}
  </b-button>
</template>

<script>
  export default {
    name: "ButtonSpinner",
    props: ['variant', 'block', 'type', 'fetching'],
    computed: {
      separator() {
        return this.$slots.default && (this.$slots.icon || this.fetching)
      }
    },
    methods: {
      onClick() {
        this.$emit('click')
      }
    }
  }
</script>

<style scoped>

</style>
